'use strict';


import { BaseElement } from './BaseElement';
import { GSAPAnimationMixer, TRoot } from '../../settings';
import { changeLangToCurrent } from '../components/langSwitcher/langSwitcher';
import gsap from 'gsap';

export class ConfirmMessage {
	constructor (messageOrDictionaryKey, onCallback, duration = 0.5) {
		
		this.callback = onCallback;
		this.duration = duration;
		this.container = new BaseElement()
			.addClass('dreams-confirm')
			.appendTo(TRoot);
		
		const top = new BaseElement()
			.addClass('dreams-confirm__top')
			.appendTo(this.container.DOMElement)
			.DOMElement;
		
		const bottom = new BaseElement()
			.addClass('dreams-confirm__bottom')
			.appendTo(this.container.DOMElement)
			.DOMElement;
		
		new BaseElement('h3')
			.addClass('dreams-confirm__title','language-string')
			.addAttribute('data-dictionary',messageOrDictionaryKey)
			.innerHtml(changeLangToCurrent(messageOrDictionaryKey))
			.appendTo(top);
		
		new BaseElement('button')
			.addClass('dreams-confirm-btn','--agree-btn','language-string')
			.addAttribute('data-dictionary','Disagree')
			.innerHtml(changeLangToCurrent('Disagree'))
			.event('click',this.hide.bind(this,'Disagree'))
			.appendTo(bottom);
		
		new BaseElement('button')
			.addClass('dreams-confirm-btn','--agree-btn','language-string')
			.addAttribute('data-dictionary','Agree')
			.innerHtml(changeLangToCurrent('Agree'))
			.event('click',this.hide.bind(this,'Agree'))
			.appendTo(bottom);
		
		this.show();
	}
	
	show() {
		gsap.to(this.container.DOMElement,{
			opacity: 1,
			ease: GSAPAnimationMixer.ease,
			duration: this.duration
		});
	}
	
	hide(state) {
		gsap.to(this.container.DOMElement,{
			opacity: 0,
			ease: GSAPAnimationMixer.ease,
			duration: this.duration,
			onComplete: () => {
				this.container.remove();
				this.callback(state);
				this.container = null;
				this.callback = null;
				this.duration = null;
			}
		});
	}
	
}
